import { atom } from "recoil";


const motherIdAtom = atom({
    key: 'motherId',
    default: {},
});
  
export default motherIdAtom